<template>
	<v-app>
		<nav class="navbar navbar-light navbar-expand-md nav_background">
			<v-container px-6 py-0>
				<router-link to="/" class="navbar-brand">
					<font-awesome-icon icon="home" />
					<span class="onlymob">&nbsp;События «Гермес»</span>
				</router-link>
				<button
					class="navbar-toggler"
					type="button"
					data-bs-toggle="collapse"
					data-bs-target="#mainMenuBar"
					aria-controls="mainMenuBar"
					aria-expanded="false"
					aria-label="Toggle navigation"
				>
					<span class="navbar-toggler-icon"></span>
				</button>
				<div class="collapse navbar-collapse" id="mainMenuBar">
					<ul class="navbar-nav me-md-auto mb-md-0">
						<li class="nav-item dropdown" v-if="loggedIn">
							<a
								class="nav-link dropdown-toggle"
								href="#"
								id="navbarDropdown"
								role="button"
								data-bs-toggle="dropdown"
								aria-expanded="false"
								v-show="false"
							>
								Dropdown
							</a>
							<ul class="dropdown-menu" aria-labelledby="navbarDropdown">
								<li v-if="showAdminBoard">
									<router-link to="/admin" class="dropdown-item">Admin Board</router-link>
								</li>
								<li v-if="showModeratorBoard">
									<router-link to="/mod" class="dropdown-item">Moderator Board</router-link>
								</li>
								<li v-if="currentUser">
									<router-link to="/user" class="dropdown-item">User Board</router-link>
								</li>
							</ul>
						</li>

						<li class="nav-item">
							<router-link to="/events" class="nav-link"><font-awesome-icon icon="star" /> Все события</router-link>
						</li>
						<template v-if="showAdminBoard || showModeratorBoard">
							<li class="nav-item">
								<router-link to="/events/add" class="nav-link"
									><font-awesome-icon icon="fas fa-calendar-plus" /> Создать событие</router-link
								>
							</li>
							<li class="nav-item">
								<a href="/panel/" class="nav-link" target="_blank"
									><font-awesome-icon icon="fas fa-cat" /> Админка (CRUD)</a
								>
							</li>
						</template>
					</ul>
					<div class="d-flex justify-content-start align-items-center">
						<nav class="navbar navbar-expand navbar-light">
							<div class="navbar-nav ml-md-auto align-items-center">
								<li class="nav-item">
									<span class="nav-link text-muted">Профиль:</span>
								</li>
								<template v-if="!currentUser">
									<li class="nav-item">
										<router-link to="/login" class="nav-link">
											<font-awesome-icon icon="sign-in-alt" /> Войти
										</router-link>
									</li>
									<li class="nav-item">
										<router-link to="/register" class="nav-link">
											<font-awesome-icon icon="user-plus" /> Создать</router-link
										>
									</li>
								</template>
								<template v-if="currentUser">
									<li class="nav-item">
										<router-link to="/profile" class="nav-link">
											<!-- <font-awesome-icon icon="user" /> -->
											{{ currentUser.email }}
										</router-link>
									</li>
									<li class="nav-item">
										<a class="nav-link" href @click.prevent="logOut">
											<font-awesome-icon icon="sign-out-alt" /> Выход
										</a>
									</li>
								</template>
							</div>
						</nav>
					</div>
				</div>
			</v-container>
		</nav>

		<div class="container my-3">
			<router-view />
		</div>

		<footer class="container d-flex flex-wrap justify-content-between align-items-center py-3 mt-auto mb-4 border-top">
			<div class="col-12 justify-content-center col-md-4 justify-content-md-start d-flex align-items-center">
				<a href="https://cmt-germes.ru" target="_blank" class="mb-3 me-2 mb-md-0 text-muted text-decoration-none lh-1">
					<span class="text-muted">© {{ new Date() | moment("YYYY") }} ГБОУ ДО ЦРТДЮ «Гермес»</span>
				</a>
			</div>
			<div class="col-12 justify-content-center col-md-4 justify-content-md-center d-flex align-items-center">
				<a href="mailto:help.events@cmt-germes.ru" class="mb-3 me-2 mb-md-0 text-muted text-decoration-none lh-1">
					<span class="text-muted">help.events@cmt-germes.ru</span>
				</a>
			</div>

			<ul
				class="nav d-flex col-12 col-md-4 justify-content-around justify-content-md-end px-3 px-md-auto list-unstyled"
			>
				<li class="me-3 ms-md-3" v-for="(soc, index) in socials" :key="index">
					<a class="text-muted" target="_blank" :href="soc.url" :title="soc.name"
						><font-awesome-icon class="fa-xl" :icon="soc.icon"
					/></a>
				</li>
			</ul>
		</footer>
	</v-app>
</template>

<script>
export default {
	metaInfo: {
		title: process.env.VUE_APP_TITLE,
		titleTemplate: "%s | ГБОУ ДО ЦРТДЮ «Гермес»",
		htmlAttrs: {
			lang: "ru-RU",
		},
		meta: [
			{ charset: "utf-8" },
			{ name: "description", content: "An example Vue application with vue-meta." },
			{ name: "viewport", content: "width=device-width, initial-scale=1" },
		],
	},
	data() {
		return {
			socials: [
				{ name: "Telegram", url: "https://t.me/germes_sao", icon: "fa-brands fa-telegram" },
				{ name: "Вконтакте", url: "https://vk.com/cmt_germes", icon: "fa-brands fa-vk" },
				{ name: "RuTube", url: "https://rutube.ru/channel/24214437/", icon: "fa-film" },
				{ name: "YouTube", url: "https://www.youtube.com/user/cmtgermes", icon: "fa-brands fa-youtube" },
			],
		};
	},
	computed: {
		currentUser() {
			return this.$store.state.auth.user;
		},
		showAdminBoard() {
			if (this.currentUser && this.currentUser.roles) {
				return this.currentUser.roles.includes("ROLE_ADMIN");
			}

			return false;
		},
		showModeratorBoard() {
			if (this.currentUser && this.currentUser.roles) {
				return this.currentUser.roles.includes("ROLE_MODERATOR");
			}

			return false;
		},
		loggedIn() {
			return this.$store.state.auth.status.loggedIn;
		},
	},
	async created() {
		await this.$store.dispatch("params/getParams");
		await this.$store.dispatch("params/getSlides");
		this.$store.dispatch("user/loginStatus");
	},
	async mounted() {},
	methods: {
		logOut() {
			this.$store.dispatch("auth/logout");
			this.$router.push("/");
		},
	},
	watch: {
		$route() {
			document.getElementById("mainMenuBar").classList.remove("show");
		},
	},
};
</script>

<style scoped>
.v-application ul,
.v-application ol {
	padding-left: 0;
}

.nav_background {
	background-color: var(--accent-color);
	box-shadow: 0px 4px 12px rgb(0 0 0 / 10%);
}

@media (min-width: 569px) {
	.onlymob {
		display: none;
	}
}

.navbar-expand .navbar-nav .nav-link:first-child {
	padding-left: 0;
}

/* .btn-primary {
	background-color: var(--accent-color);
} */
</style>
